import React, { memo, Suspense, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { DefaultCustomTemplate } from "../template"

export const Header = memo(() => {
    // some little workaround to get current translation
    const { i18n } = useTranslation()

    const [views, setViews] = useState<React.JSX.Element | undefined>()
    const currentLanguage = useRef<string>()

    useEffect(() => {
        if (!currentLanguage.current || currentLanguage.current != i18n.language) {
            currentLanguage.current = i18n.language
            DefaultCustomTemplate(setViews, "Header")
        }
    }, [i18n.language])

    return (
        <Suspense fallback={<div>Loading ...</div>}>
            <header>{views}</header>
        </Suspense>
    )
})

Header.displayName = "header"
